import { render, staticRenderFns } from "./wrongTopic.vue?vue&type=template&id=0684e0dc&scoped=true&"
import script from "./wrongTopic.vue?vue&type=script&lang=js&"
export * from "./wrongTopic.vue?vue&type=script&lang=js&"
import style0 from "./wrongTopic.vue?vue&type=style&index=0&id=0684e0dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0684e0dc",
  null
  
)

export default component.exports